import { React, useState, useEffect, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import Hover from "../OnHoverDetails/Hover";

var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Layout10(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);
  // const [isHovered, setHovered] = useState(false);  

  // const handleMouseEnter = () => {
  //   setHovered(true);
  // };

  // const handleMouseLeave = () => {
  //   setHovered(false);
  // };

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  return (
    <>
      {window.innerWidth > 768 ?
        <>
          <section className="mb-0 dD-block">
            <div className="temp15">
              {/* {showShimmer ? (
                <div className="linedesk" />
              ) : ( */}
              <>
                <div className="head-layout">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                  <div className="arrow-layout">
                    {props.title.show_more ? (
                      <Link to={"/baypage/" + props.title.slug}>
                        <div className="hoverText">View All</div>
                      </Link>
                    ) : null}
                    <div className="arrow-icon">
                      {props.title.show_more ? (
                        <Link to={"/baypage/" + props.title.slug}>
                          <img src={SVGIcon["right-arrow.svg"]} />
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
              {/* )} */}

              <div className="temp15-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  slidesPerView={2.4}
                  spaceBetween={16}
                  slidesPerGroup={6}
                  freeMode={true}
                  loop={false}
                  roundLengths={true}
                  // loopAdditionalSlides={30}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 5,
                    },
                    850: {
                      slidesPerView: 6.4,
                    },
                  }}
                  modules={[FreeMode, Pagination, Navigation]}
                  className="temp15-slider"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button className="slick-prev slick-arrow" type="button" />
                  {props.title.contents.map((data, index) => {
                    // var GenereTitle = data.genres.split(",");
                    // GenereTitle = GenereTitle[0];
                    var keyword = data.keywords.split(",")[0];
                    var premium = "";
                    if (data.premium && !data.original_tag) {
                      var premium = (
                        <img
                          src={props.silverIcon}
                          style={{
                            width: "1.7rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    if (data.original_tag && data.premium) {
                      var original = (
                        <img
                          src={props.goldenIcon}
                          style={{
                            width: "1.7rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    return (
                      <SwiperSlide key={index} className="temp15-item">
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <div className="temp15-itemColor">
                            {/* <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}> */}
                            <img src={data.thumbnail_image2.small} alt="DocuBay" className="temp15-img" />
                            {/* {isHovered &&  } */}
                            <Hover
                              data={data}
                              silverIcon={props.silverIcon}
                              goldenIcon={props.goldenIcon}
                            />
                            {/* </div> */}
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </div>
                          <div className="bay-title">{keyword}</div>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </section>
        </> :
        <>
          <section className="mb-0 dD-none">
            <div className="temp15">
              {/* {showShimmer ? (
                <div className="line linehead" />
              ) : ( */}
              <>
                <div className="head">
                  <h4>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h4>
                  {props.title.show_more ? (
                    <Link to={"/baypage/" + props.title.slug}>
                      {" "}
                      <img src={SVGIcon["right-arrow.svg"]} />{" "}
                    </Link>
                  ) : null}
                </div>
              </>
              {/* // )} */}
              <div className="temp15-area">
                <Swiper
                  slidesPerView={2.4}
                  spaceBetween={16}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    700: {
                      slidesPerView: 3.9,
                    },
                    820: {
                      slidesPerView: 3.9,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[FreeMode, Pagination]}
                  className="temp15-slider"
                >
                  {props.title.contents.map((data, index) => {
                    // var GenereTitle = data.genres.split(",");
                    // GenereTitle = GenereTitle[0];
                    var premium = "";
                    var keyword = data.keywords.split(",")[0];
                    if (data.premium && !data.original_tag) {
                      var premium = (
                        <img
                          src={props.silverIcon}
                          style={{
                            width: "1.3rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }
                    if (data.original_tag && data.premium) {
                      var original = (
                        <img
                          src={props.goldenIcon}
                          style={{
                            width: "1.3rem",
                            marginRight: "3px",
                            marginBottom: "2px",
                          }}
                        />
                      );
                    }

                    return (
                      <SwiperSlide key={index} className="temp15-item">
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <a
                            onClick={() => {
                              showdetailspop(data);
                            }}
                          >
                            <div className="temp15-itemColor">
                              <img src={data.thumbnail_image2.small} alt="DocuBay" />
                              <div className="premium-red">
                                {premium}
                                {original}
                              </div>
                            </div>
                          </a>
                          <div className="bay-title">{keyword}</div>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                </Swiper>
              </div>
            </div>
          </section>
        </>
      }

      {/* <div className="latestBay"> */}

      {/* </div> */}
      {showdetails ? (
        <Showdetailspopup data={details} Closebtn={Closepopup} silverIcon={props.silverIcon} goldenIcon={props.goldenIcon} />
      ) : null}
    </>
  );
}

export default Layout10;